import React from "react";
import icon_delete from "../../../layout/others/icon_delete.svg";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "../../styles/forms.scss";
import Select from "../../../components/Select";

const NationalityPersonalInformation = ({ index }) => {
  const {
    interview,
    setInterview,
    nationality,
    errors
  } = useInterviewContext();
  const { t } = useTranslation();

  const deleteNationality = (index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        nationalityId: prevInterview.personalInformation.nationalityId.filter(
          (id, idIndex) => idIndex !== index
        )
      }
    }));
  };

  function onChangeNationality({ target }, index) {
    let personalInformation = { ...interview.personalInformation };
    const PT = 1;
    if (Number(target.value) === PT)
      personalInformation.isForeingWithOutDoc = false;

    if (!personalInformation.nationalityId.includes(Number(target.value)))
      personalInformation.nationalityId[index] = target.value;

    setInterview({ ...interview, personalInformation: personalInformation });
  }

  const onChangeNeedsDocumentation = () => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      personalInformation: {
        ...prevInterview.personalInformation,
        isForeingWithOutDoc:
          interview.personalInformation.isForeingWithOutDoc === true
            ? false
            : true
      }
    }));
  };

  return (
    <div className="nationality">
      <div className="form-group">
        <div className="label-wrapper">
          {index === 0 && (
            <label htmlFor="personalDetailLabelNationality">
              {t("Nationality")}*
            </label>
          )}
          {index === 0 && errors.nationalityId && (
            <div className="error-msg">{errors.nationalityId}</div>
          )}
        </div>
        <Select
          id="nationalityId"
          name="nationalityId"
          onChange={(event) => onChangeNationality(event, index)}
          value={interview.personalInformation.nationalityId[index] || 0}
          style={{ width: "100%", minWidth: "340px" }}
          required
          title={t("Selecione um item da lista.")}
        >
          <option value={0} selected disabled>
            {t("Select a nationality...")}
          </option>
          {nationality.map((item) => {
            if (item.id === 1) {
              return (
                <option key={index} value={item.id} selected={true}>
                  {t(item.description)}
                </option>
              );
            } else {
              return (
                <option key={index} value={item.id}>
                  {t(item.description)}
                </option>
              );
            }
          })}
        </Select>
      </div>
      {index === 0 && (
        <div className="needs-documentation">
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            {t("Need Documentation?")}
          </label>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="isForeingWithOutDoc"
              name="isForeingWithOutDoc"
              onChange={onChangeNeedsDocumentation}
              checked={interview.personalInformation.isForeingWithOutDoc}
              value={interview.personalInformation.isForeingWithOutDoc}
              disabled={interview.personalInformation.nationalityId.includes(1)}
            />
          </div>
        </div>
      )}
      <button
        type="button"
        className="app-button btn-second btn-md"
        onClick={() => deleteNationality(index)}
        style={{ display: index === 0 ? "none" : "block", marginLeft: "20px" }}
      >
        <img src={icon_delete} alt="delete" width="12px" height="auto" />{" "}
        {t("Delete")}
      </button>
    </div>
  );
};

export default NationalityPersonalInformation;

NationalityPersonalInformation.propTypes = {
  index: PropTypes.number.isRequired,
  nationalityId: PropTypes.any
};
